import { ConditionEvaluator } from '@leverege/condition';
import { point } from '@turf/helpers';
import turfDistance from '@turf/distance';
export default class GeoPointDistanceComparatorEvaluator extends ConditionEvaluator {
  satisfies(context) {
    const {
      attribute,
      target
    } = context;
    const targetValue = attribute?.get(target?.data);
    const value1 = this.model.value1;
    const distance = this.model.distance;
    const units = this.model.units;
    const not = this.not;
    if (value1 == null || distance == null || units == null || targetValue == null) {
      return null;
    }
    const targetPoint = point([targetValue.lon, targetValue.lat]);
    const point1 = point([value1.lon, value1.lat]);
    const d = turfDistance(targetPoint, point1, {
      units
    });
    if (not) {
      return d > distance;
    }
    return d <= distance;
  }
}